// 달력달력
const DAY_OF_MONTH = [31,28,31,30,31,30,31,31,30,31,30,31];
const MONTH_ABBR   = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']

// 이거 맞나?
const TIMEZONE = (function() {
    var now = new Date();
    var offset = -now.getTimezoneOffset()/60;
    var timezone = '';
    timezone += offset>=0?'+':'-';
    timezone += -10<offset && offset<10?'0':'';
    timezone += offset>=0?offset:-offset;
    timezone += '00';
    return timezone;
})()

//================================================
// [FUNCTION] Debounce
//     : 연이어 호출되는 함수들 중 마지막 함수(또는 제일 처음)만 호출하도록 하는 것
export const _debounce = (func, wait, immediate) => {
    if(!wait) {func()} 
    let timeout
    return function () {
        const context = this, args = arguments
        const later = function () {
            timeout = null
            if (!immediate) {
                func.apply(context, args)
            }
        }
        const callNow = immediate && !timeout
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
        if (callNow) {
            func.apply(context, args)
        }
    }
}

//================================================
// [FUNCTION] Throttle
//     : 마지막 함수가 호출된 후 일정 시간이 지나기 전에 다시 호출되지 않도록 하는 것
//       ex) _throttle(()=>{}, 300, false)
export const _throttle = (func, wait, immediate) => {
    let timeout
    return function () {
        if(this?this.__timeout:timeout) return;
        const context = this, args = arguments
        const releaseThrottle = function () {
            if(context) {context.__timeout = null}
            else {timeout = null}
            if(!immediate) func.apply(context, args)
        }
        var t = setTimeout(releaseThrottle, wait)
        if(this) {this.__timeout = t}
        else {timeout = t}
        if(immediate) func.apply(context, args)
    }
}

//================================================
//[FUNCTION] reqAniFrame -> 
//  : requestAnimationFrame을 사용한 throttle
//    ex) _rafThrottle(()=>{})
export const _rafThrottle = (func) => {
    let __rafFlag = false;
    return function() {
        if(this?this.__rafFlag:__rafFlag) {return;}
        const context = this, args = arguments
        requestAnimationFrame(()=> {
            if(this) {this.__rafFlag = false}
            else {__rafFlag = false}
            setTimeout(()=>{
                func.apply(context, args);
            },10)
        })
        __rafFlag = true;
        if(this) {this.__rafFlag = true}
        else {__rafFlag = true}
        return;
    }
}

//================================================
// [FUNCTION] isNull
//     : 값이 없거나 배열이 비어있는지 여부를 판단함
//  0 이나 false등은 값이 있는것으로 간주
export function isNull(v) {
    if(!!v && Array.isArray(v) && !v.length) {return true}
    return v === undefined || v === null || v === '' || Number.isNaN(v)
}

//================================================
// [FUNCTION] CHECKER
//     : 기본 제공 체크 함수 입니다.
export const CHECKER = {
    stringLike  : (v, f) => v.indexOf(f)!== -1,
    stringMatch : (v, f) => v === f, 
    stringCaseIgnore : (v, f) => {
        return v.toLowerCase().indexOf(f.toLowerCase())!== -1;
    },
    number : (v, f) => v === f,
    numberRange : (v, f) => {
        if(!Array.isArray(f) || f.length !== 2) return false;
        if(f[0] && v < f[0]) return false;
        if(f[1] && f[1] < v) return false;
        return true;
    },
    date   : (v,f) => {
        if(!f) return false;
        var st = new Date(f.getFullYear(), f.getMonth(), f.getDate()),
            ed = new Date(f.getFullYear(), f.getMonth(), f.getDate()+1);
        return !!v && st<v && v<ed;
    },
    dateRange : (v,f) => {
        var st, ed, flag=true;
        if(f[0]) {
            st = new Date(f[0].getFullYear(), f[0].getMonth(), f[0].getDate())
            flag = /*flag &&*/ st<v
        }
        if(f[1]) {
            ed = new Date(f[1].getFullYear(), f[1].getMonth(), f[1].getDate()+1)
            flag = flag && v<ed
        }
        return flag;
    },
    boolean: (v,f) => undefined !== f.find(val => !!v===!!val),
    code   : (v,f) => undefined !== f.find(val => v===val),
    // in most cases. default checker
    match : (v, f) => v === f
    
}

//================================================
//[FUNCTION][DATE] Is valid date
//  : 이게? 날짜입니까?
function isValidDate(dt) {
 return !(dt && isNaN(dt.getYear()));
}
//================================================
//[FUNCTION][DATE] Is valid date
//  : 이건 또 윤년일까요?
//    1 = 윤년, 0 = 안윤년
export const isLeaf = (y) => y%400?(y%100?(y%4?0:1):0):1;
//================================================
// [FUNCTION][DATE] Text to Date
// : 문자열을 날짜로 바꿉니다.
export function textToDate(text, format) {
    // 0. precheck
    if(!text || !format) return null;
    if(text.length !== format.length) return null;
    var _fmt = format.toUpperCase();
    var iy, im, id, y, m, d, today = new Date();
    // 1. get Year
    if( (iy = _fmt.indexOf('YYYY')) >= 0) {
        y = parseInt(text.substr(iy,4));
    } else if((iy = _fmt.indexOf('YY')) >= 0) {
        y = parseInt(text.substr(iy,2));
        if(y<70) y+= 2000;
        else y+= 1900;
    } else {
        y = today.getFullYear();
    }
    // 2. get Month
    if( (im = _fmt.indexOf('MM')) >= 0) {
        m = parseInt(text.substr(im,2))-1;
    } else {
        m = today.getMonth();
    }
    // 2.x min/max adjust
    if(m<0) m=0;
    if(m>11) m=11;
    // TODO How about 'M'
    // TODO How about 'MMM'
    // 3. get Day
    if( (id = _fmt.indexOf('DD')) >= 0) {
        d = parseInt(text.substr(id,2));
    } else {
        d = today.getDate();
    }
    // 3.x min/max adjust
    if(d<1) {d=1}
    var maxD = DAY_OF_MONTH[m] + (m===1?isLeaf(y):0);
    if(d>maxD) { d = maxD; }
    // TODO How about 'D'
    // x. make date
    // TODO do some validate
    return new Date(y,m,d);
}
//================================================
// [FUNCTION][DATE] Date to Text
//     : 날짜를 문자열로 바꿉니다
//     : slow -> 개선 가능?
export /* NOSONAR */function dateToText(_date, format, timezone) {
    // 0. precheck
    if(!_date) {
        return '';
    } else if(typeof _date === 'number') {
        _date = new Date(_date);
    } else if(typeof _date === 'string') {
        var _temp = new Date(_date);
        if(isNaN(_temp.getTime())) {return _date}
        _date = _temp
    } else if(!(_date instanceof Date)) {
        return _date
    }
    // 0.1 apply timezone
    var dt = _date;
    if(typeof timezone === 'number') {
        const OF = _date.getTimezoneOffset();
        const TZ = timezone * -1 * 60;
        dt = new Date(_date.getTime() + (OF-TZ)*60*1000);
    }
    // TODO null check format
    var _fmt = format;
    var rtn = _fmt,
        year  = dt.getFullYear(),
        month = dt.getMonth()+1,
        date  = dt.getDate(),
        hour  = dt.getHours(),
        minute= dt.getMinutes(),
        second= dt.getSeconds();
    // 1. convert Year
    if( _fmt.indexOf('YYYY') >= 0 || _fmt.indexOf('yyyy') >= 0) {
        rtn = rtn.replace(/YYYY/gi,("000"+year).slice(-4))
    } else if( _fmt.indexOf('YY') >= 0 || _fmt.indexOf('yy') >= 0) {
        rtn = rtn.replace(/YY/gi,("0"+year).slice(-2));
    }
    // 2. convert Month
    if( _fmt.indexOf('MMM') >= 0) {
        rtn = rtn.replace(/MMM/g,MONTH_ABBR[month-1]);
    } else if( _fmt.indexOf('MM') >= 0) {
        rtn = rtn.replace(/MM/g,("0"+month).slice(-2));
    } else if( _fmt.indexOf('M') >= 0) {
        rtn = rtn.replace(/M/g, month);
    }
    // 3. convert Month
    if( _fmt.indexOf('DD') >= 0 || _fmt.indexOf('dd') >= 0) {
        rtn = rtn.replace(/DD/gi,("0"+date).slice(-2));
    } else if( _fmt.indexOf('D') >= 0 || _fmt.indexOf('d') >= 0) {
        rtn = rtn.replace(/D/gi,date);
    }
    // 4. convert hour
    if( _fmt.indexOf('HH') >= 0) {
        rtn = rtn.replace(/HH/g,("0"+hour).slice(-2));
    } else if( _fmt.indexOf('H') >= 0) {
        rtn = rtn.replace(/H/g,hour);
    } else if( _fmt.indexOf('hh') >= 0) {
        rtn = rtn.replace(/hh/g,("0"+(hour%12)).slice(-2));
    } else if( _fmt.indexOf('h') >= 0) {
        rtn = rtn.replace(/h/g,hour%12);
    }
    if( _fmt.indexOf('a') >= 0) {
        rtn = rtn.replace(/a/g,hour<12?'am':'pm');
    } else if (_fmt.indexOf('A') >= 0) {
        rtn = rtn.replace(/A/g,hour<12?'AM':'PM');
    }
    // 5. convert minute
    if( _fmt.indexOf('mm') >= 0) {
        rtn = rtn.replace(/mm/g,("0"+minute).slice(-2));
    } else if( _fmt.indexOf('m') >= 0) {
        rtn = rtn.replace(/m/g,minute);
    }
    // 6. convert second
    if( _fmt.indexOf('ss') >= 0) {
        rtn = rtn.replace(/ss/g,("0"+second).slice(-2));
    } else if( _fmt.indexOf('s') >= 0) {
        rtn = rtn.replace(/s/g,second);
    }
    
    return rtn;
}


export function convNumberFormat(x, fmt) {
    // 1. Parse fmt
    // 1.1 Get spliter
    var ch = fmt.match(/[^#]/g)
    if(ch === null) {return x.toString();}
    var sp = ch[0], pt = ch[ch.length-1];
    // 1.2 Split digit/decimal pt.
    var idx = fmt.indexOf(pt), dg, dc;
    if(idx > 0) {
        dg = fmt.substr(0,idx);
        dc = fmt.substr(idx+1,fmt.length);
    } else {
        dg = fmt;
        dc = '';
    }
    // 1.3 Get digit length
    var gidx = dg.indexOf(sp),
        glen = dg.length -gidx-1;
    var clen = dc.length;
    // 2. Apply format
    let parts = x.toString().split('.'),
        regex = new RegExp("\\B(?=(\\d{"+glen+"})+(?!\\d))","g");
    parts[0] = parts[0].replace(regex, sp);
    if(!dc || !parts[1]) return parts[0];
    parts[1] = (parts[1]).substr(0,clen);
    return parts[0] + pt + parts[1];
}


//================================================
//[FUNCTION][COPY] Copy object
//  : 객체를 복사합니다.
export function copyArr(arr) {
    return arr.map(r=>copyObj(r));
}
//================================================
//[FUNCTION][COPY] Copy object
//  : 객체를 복사합니다.
//      - 1차 : Parse(Stringify(obj))
//      - 2차(4/8) : 절반의 deepcopy
//      - 3차(4/9) : 반에반의 deep...
//      - 4차(4/21): 속도 개선
//      - 5차(4/23): deepcopy /w 재귀
//      - 6차(5/14): Symbol삭제, bugfix(null 이슈, array copy 등)
export function copyObj(t, o) {
    /********** 6차(2020-05-14) **********/
    // 1. Align argmuents
    var _t, _o; // origin & target
    if(o === undefined) {
        _t={};
        _o=t;
    } // Single mode -> clone object
    else {
        _t = t;
        _o = o;
    }// Copy to mode

    // 2. check primitive type & null
    if(!_o || typeof _o !== 'object') return _o;
    // 3. copy attr(recursive)
    for(var k in _o) {
        var v = _o[k];
        if(Array.isArray(_o[k])) {
            _t[k] = copyArr(v);
        } else if(v && typeof v === 'object') {
            if(v instanceof Date) {
                _t[k] = new Date(v);
            } else {
                _t[k] = copyObj(v) ;
            }
        } else {
            _t[k] = v;
        }
    }
    return _t;
}


//================================================
//[FUNCTION][TOY] getKey
//: 16진수 Key를 생성합니다. 0x100000~0xffffff (15,728,639개)
const __KEYIDX_DEFAULT = 0x100000,
      __KEYIDX_MAX     = 0xffffff;
const __keyBox = {};
export function getKey(walnut) {
    // 1. Catch walnut
    var __walnut = walnut || 'default'
    // 2. Check walnut index
    if(!__keyBox.hasOwnProperty(__walnut)) {
        __keyBox[__walnut] = __KEYIDX_DEFAULT
    }
    // 3. Make next key index
    var nKeyIdx = __keyBox[__walnut]++;
    if(nKeyIdx > __KEYIDX_MAX) nKeyIdx = __KEYIDX_DEFAULT;
    
    // x. Set key
    return 'key_'+__walnut+'_'+nKeyIdx.toString(16).slice(-6);
}